<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { Payment } from '../../../../Types/invoice'
import PaymentListItem from './PaymentListItem.vue'

const props = withDefaults(
  defineProps<{
    payments?: Payment[]
  }>(),
  {
    payments: () => [],
  },
)

const { t } = useI18n()
</script>

<template>
  <div class="table-responsive">
    <table class="table table-striped mb-0">
      <thead>
        <tr>
          <th class="font-weight-bold col-2">{{ t('invoice.label.label') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.dueAt') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.status') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.paidAt') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.rejectedAt') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.label.amount') }}</th>
        </tr>
      </thead>
      <tbody>
        <PaymentListItem v-for="payment in payments" :key="payment.id" :payment="payment" />
        <tr v-if="!payments?.length">
          <td colspan="6" class="text-center">
            {{ t('invoice.title.emptyPayments') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
